import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const FeatureItem = ({ text }) => (
  <Grid item xs={12} md={4}>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 20,
          height: 20,
          minWidth: 20,
          flexShrink: 0,
          borderRadius: "50%",
          bgcolor: "rgba(255,255,255,0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" color="white" fontWeight={700}>
          ✓
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ opacity: 0.95 }}>
        {text}
      </Typography>
    </Box>
  </Grid>
);

export default FeatureItem;
